import React from 'react'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import DateDisplay from '../../../../../../components/DateDisplay'
import { DistributionDetailsById } from 'src/queries'

interface ListProps {
  distribution: DistributionDetailsById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { distribution } = props
  const section: Array<Omit<ItemProps, 'id'>> = [
    { title: 'Category', value: distribution?._category?.name },
    { title: 'Subcategory', value: distribution?._subcategory?.name },
    {
      title: 'Date Posted/Sent',
      value: <DateDisplay id='date_posted' date={distribution?.date_posted} />
    }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: distribution === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <DescriptionList {...dlProps}>
      {section.map(item => {
        const key = item.title.toLowerCase().replace(' ', '-')
        return <Item {...item} key={key} id={key} />
      })}
    </DescriptionList>
  )
}

export default List
